/**
 * Module jds kya
 * @module app.kya.jds
 */
define(['angular', 'modules/kya/jds/controllers/kyaJdsCtrl'], function(angular) {


    /**
     * Configure routing
     * @param $routeProvider
     */
    function kiaJdsRouter($routeProvider) {
        $routeProvider.when('/kya/jds/', {
            templateUrl: 'kya/jds/partials/jds.html',
            controller: 'KyaJdsCtrl',
            controllerAs: 'kyaJdsCtrl',
            params: {
                menuTitle: 'Journal des signatures KYA'
            }
        });
    }

    kiaJdsRouter.$inject = ['$routeProvider'];

    angular.module('app.kya.jds', ['app.kya.jds.kyaJdsCtrl']).config(kiaJdsRouter);
});
